<template>
    <div>
        <b-navbar toggleable="lg" type="light" class="bg-secondary-system">
            <b-navbar-brand href="#"><img alt="Meo Empresas" src="@/assets/images/logo.png" class="logo-horizon"></b-navbar-brand>
            <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->
            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <!-- <b-nav-item href="#">survey</b-nav-item> -->
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <div class="row no-gutters">
            <div class="col-lg-12">
                <div class="breadcrumbs-bar">
                    <div class="content-holder">
                        <ul class="hyperlinks">
                            <li></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.logo-horizon {
    float: left;
    margin: 0 15px 0;
    width: 100px;
}
.bg-secondary-system {
  background-color: #000000 !important;
  border: none;
//   border-bottom: 5px solid transparent;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
}
</style>
